import React, { Fragment, useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import { Link } from 'react-router';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import ChevronLeft from 'material-ui/svg-icons/navigation/chevron-left';
import ChevronRight from 'material-ui/svg-icons/navigation/chevron-right';
import { Checkbox, IconButton, RaisedButton, TextField, Table, TableBody, TableHeader, TableHeaderColumn, TableRow } from 'material-ui';

import PortsTableRow from './Row';

import { getPorts } from 'actions/regions/ports';
import styles from 'styles';

const PortsListTable = (props) => {
    const { ports, getPorts } = props;

    const [page, setPage] = useState(1);
    const [portsList, setPortsList] = useState([]);
    const [sort, setSort] = useState('name');
    const [query, setQuery] = useState(ports.query);
    const [onlyChanged, setOnlyChanged] = useState(ports.onlyChanged || false);
    const [hasRecommended, setHasRecommended] = useState(ports.hasRecommended || false);
    const [expiredRecommended, setExpiredRecommended] = useState(undefined);
    const [loading, setLoading] = useState(false);
    const isLoadingRef = useRef(false);

    const changePortList = ({ direction = undefined }) => {
        if (isLoadingRef.current) return;
        let newPage = 1;

        if (typeof direction !== 'undefined' && ports.previous && direction < 0) {
            newPage = ports.previous;
        } else if (typeof direction !== 'undefined' && ports.next && direction > 0) {
            newPage = ports.next;
        }

        isLoadingRef.current = true;
        setLoading(true);
        
        getPorts({
            page: newPage,
            query,
            onlyChanged,
            sort,
            hasRecommended,
        });
    };

    /**
     * 
     * @param {{
        *  onlyChanged?: boolean,
        *  hasRecommended?: boolean,
        *  expiredRecommended?: boolean,
        * }} opts
        */
    const resetAndLoadPorts = (opts) => {
        setPage(1);
        getPorts({
            page: 1,
            query,
            onlyChanged: opts.onlyChanged,
            hasRecommended: opts.hasRecommended,
            expiredRecommended: opts.expiredRecommended,
        });
    };

    const isOnlyChanged = () => {
        const newOnlyChanged = onlyChanged ? undefined : true;
        setOnlyChanged(newOnlyChanged);
        resetAndLoadPorts({ onlyChanged: newOnlyChanged, hasRecommended, expiredRecommended });
    };

    const isWithRecommendedProviders = () => {
        const newHasRecommended = hasRecommended ? undefined : true;
        setHasRecommended(newHasRecommended);
        resetAndLoadPorts({ hasRecommended: newHasRecommended, onlyChanged, expiredRecommended });
    };

    const isWithExpiredRecommendedProviders = () => {
        const newExpiredRecommended = expiredRecommended ? undefined : true;
        setExpiredRecommended(newExpiredRecommended);
        resetAndLoadPorts({ expiredRecommended: newExpiredRecommended, onlyChanged, hasRecommended });
    };

    const nextPage = () => {
        changePortList({ direction: 1 });
    };

    const prevPage = () => {
        changePortList({ direction: -1 });
    };

    const handleChangeSearch = (e, value) => {
        setQuery(value);
    };

    const handleSearch = () => {
        changePortList({});
    };

    useEffect(() => {
        if (ports.isLoaded) {
            setPortsList(ports.data);
            setPage(ports.page);
            setLoading(false);
            isLoadingRef.current = false;
        }
    }, [ports.isLoaded]);

    useEffect(() => {
        if (ports.query !== query) {
            setQuery(ports.query);
        }

        setOnlyChanged(ports.onlyChanged);
        setHasRecommended(ports.hasRecommended);
    }, [ports.query, ports.onlyChanged, ports.hasRecommended]);

    return (
        <Fragment>
            <div className='paper-block'>
                <div className='row'>
                    <div className='col-xs-4 center-xs middle-xs' style={{ display: 'flex' }}>
                        <TextField
                            defaultValue={query}
                            floatingLabelText='Search by name'
                            onChange={handleChangeSearch}
                            disabled={loading}
                            onKeyPress={(event) => {
                                if (event.charCode === 13) {
                                    event.preventDefault();
                                    handleSearch();
                                }
                            }}
                        />

                        <RaisedButton
                            label='Search'
                            style={styles.RaisedButton}
                            primary
                            disabled={loading}
                            onClick={handleSearch}
                        />
                    </div>
                    <div
                        className='col-xs-4 start-xs middle-xs'
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '2px', 
                            fontSize: '13px',
                        }}
                    >
                        <Checkbox
                            label='Only changed ports'
                            checked={onlyChanged}
                            disabled={loading}
                            onCheck={isOnlyChanged}
                        />
                        <Checkbox
                            label='With recommended providers'
                            checked={hasRecommended}
                            disabled={loading}
                            onCheck={isWithRecommendedProviders}
                        />

                        {/* <Checkbox
                            label='With expired recommended providers'
                            checked={expiredRecommended}
                            disabled={loading}
                            onCheck={isWithExpiredRecommendedProviders}
                        /> */}
                    </div>
                    <div className='col-xs-4 center-xs middle-xs' style={{ display: 'flex' }}>
                        <RaisedButton
                            label='Create new port'
                            style={styles.RaisedButton}
                            primary
                            disabled={loading}
                            containerElement={<Link to='/regions/ports/add' />}
                        />
                    </div>
                </div>
                <div className='row'>
                    <div className='col-xs-12 center-xs middle-xs' style={{ display: 'flex' }}>
                        <IconButton
                            iconStyle={styles.navigationLeft}
                            name='navigationLeft'
                            onClick={prevPage}
                            disabled={loading}
                        >
                            <ChevronLeft />
                        </IconButton>
                        <div className='item'>Page: {page}</div>
                        <IconButton
                            iconStyle={styles.navigationRight}
                            name='navigationRight'
                            onClick={nextPage}
                            disabled={loading}
                        >
                            <ChevronRight />
                        </IconButton>
                    </div>
                </div>
            </div>

            <div className='table-body'>
                <Table selectable={false}>
                    <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                        <TableRow>
                            <TableHeaderColumn style={styles.tableRowColumnCSS}>
                                name
                            </TableHeaderColumn>

                            <TableHeaderColumn style={styles.tableRowColumnCSS}>
                                unLoCode
                            </TableHeaderColumn>

                            <TableHeaderColumn style={styles.tableRowColumnCSS}>
                                country
                            </TableHeaderColumn>

                            <TableHeaderColumn style={styles.tableRowColumnCSS}>
                                parent name
                            </TableHeaderColumn>

                            <TableHeaderColumn style={styles.tableRowColumnCSS}>
                                Actions
                            </TableHeaderColumn>
                        </TableRow>
                    </TableHeader>

                    <TableBody displayRowCheckbox={false}>
                        {
                            ports.data.map(item => (<PortsTableRow
                                key={item._id}
                                item={item}
                            />))
                        }
                    </TableBody>
                </Table>
            </div>
        </Fragment>
    );
};

PortsListTable.propTypes = {
    ports: PropTypes.object,
    getPorts: PropTypes.func,
};

PortsListTable.defaultProps = {
    ports: {},
    getPorts: () => {
        console.error('PortsListTable didn\'t find getPorts function');
    },
};

export default connect(
    ({ ports }) => ({
        ports,
    }),
    dispatch => bindActionCreators(
        {
            getPorts,
        },
        dispatch,
    ),
)(PortsListTable);



// WEBPACK FOOTER //
// ./app/components/Regions/Ports/Table.jsx